/* BrassBoy chat rail. SPEC.md 6 + 7.3. One IIFE, no deps, no build, ES2018.
   Laws: model text never reaches innerHTML; the agent never holds a cart (a
   cut line is written here through the theme's own /cart/add.js, the way
   assets/dynamic-pricing.js:1075-1135 does); quote-form details go straight
   to rfq.metalsrus.ca and never to the chat host; sessionStorage holds only
   the session id and the open flag, never a message or a form value. */
(function () {
'use strict';

var cfgNode = document.getElementById('brassboy-config');
if (!cfgNode) return;
var CFG;
try { CFG = JSON.parse(cfgNode.textContent); } catch (e) { return; }
if (!CFG) return;
if (CFG.enabled === false && !/(^|[?&])brassboy=1(&|$)/.test(window.location.search)) return;
if (/(^|[?&])brassboy=0(&|$)/.test(window.location.search)) return;
if (!window.fetch || !window.TextDecoder || !window.Promise) return;

var S = CFG.strings || {};
var HOST = String(CFG.host || '').replace(/\/+$/, '');
var LANG = CFG.lang === 'fr' ? 'fr' : 'en';
var CART_URL = CFG.cart_url || '/cart';
var QUOTE_URL = CFG.quote_url || '/pages/quote';
var CONTACT_URL = CFG.contact_url || '/pages/customer-service';
var RFQ_URL = 'https://rfq.metalsrus.ca/submit';
var SID_KEY = 'brassboy.sid', OPEN_KEY = 'brassboy.open', MAX_MESSAGE = 1000;
var SVGNS = 'http://www.w3.org/2000/svg';

/* ---- helpers ---- */

function t(key, vars) {
  var out = typeof S[key] === 'string' ? S[key] : '';
  if (vars) Object.keys(vars).forEach(function (k) { out = out.split('{' + k + '}').join(String(vars[k])); });
  return out;
}
function el(tag, cls, text) {
  var n = document.createElement(tag);
  if (cls) n.className = cls;
  if (text != null && text !== '') n.appendChild(txt(String(text)));
  return n;
}
function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); return n; }
function add(parent, child) { parent.appendChild(child); return child; }
function attr(n, o) { Object.keys(o).forEach(function (k) { n.setAttribute(k, o[k]); }); return n; }
function txt(v) { return document.createTextNode(String(v)); }
function setText(n, text) { clear(n).appendChild(txt(text)); }
function ss(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* private mode */ } }

var money = null;
try { money = new Intl.NumberFormat(LANG === 'fr' ? 'fr-CA' : 'en-CA', { style: 'currency', currency: 'CAD' }); } catch (e) { money = null; }
function fmtMoney(v) {
  var n = Number(v);
  if (!isFinite(n)) return '';
  return money ? money.format(n) : '$' + n.toFixed(2);
}
/* Imperial first. EN prints 24.25", FR prints 24,25 po. */
function fmtIn(v) {
  var n = Number(v);
  if (!isFinite(n)) return '';
  var s = String(Math.round(n * 1000) / 1000);
  if (LANG === 'fr') s = s.replace('.', ',');
  return s + (S.unit_in != null ? S.unit_in : '"');
}

/* A link renders as a link only when it points at our own store. */
function safeUrl(raw) {
  var href = String(raw || '').trim();
  if (!href) return null;
  if (href.charAt(0) === '/' && href.charAt(1) !== '/') return href;
  /* A bare token (a knowledge doc id like "materials") is not a URL. Without
     this, new URL() resolves it against the storefront origin and a source id
     renders as a link to a page that does not exist. */
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(href)) return null;
  var u;
  try { u = new URL(href, window.location.origin); } catch (e) { return null; }
  if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
  var h = u.hostname.toLowerCase();
  if (h === window.location.hostname || h === 'metalsrus.ca' || h === 'www.metalsrus.ca' ||
      h === 'rfq.metalsrus.ca' || h === 'cdn.shopify.com' || /\.myshopify\.com$/.test(h)) return u.href;
  return null;
}
function link(href, text, cls) {
  var a = el('a', cls, text);
  a.href = safeUrl(href) || QUOTE_URL;
  a.rel = 'noopener';
  return a;
}

/* Markdown lite: paragraphs, "- " bullets, **bold**, `code`, [text](url).
   DOM nodes only, never innerHTML. */

function inlineInto(parent, text) {
  var re = /(\*\*[^*]+\*\*|`[^`]+`|\[[^\]\n]+\]\([^)\s]+\))/g, last = 0, m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parent.appendChild(txt(text.slice(last, m.index)));
    var tok = m[0];
    if (tok.charAt(0) === '*') parent.appendChild(el('strong', null, tok.slice(2, -2)));
    else if (tok.charAt(0) === '`') parent.appendChild(el('code', null, tok.slice(1, -1)));
    else {
      var cut = tok.indexOf('](');
      var label = tok.slice(1, cut), href = safeUrl(tok.slice(cut + 2, -1));
      if (href) { var a = el('a', null, label); a.href = href; a.rel = 'noopener'; parent.appendChild(a); }
      else parent.appendChild(txt(label));
    }
    last = re.lastIndex;
  }
  if (last < text.length) parent.appendChild(txt(text.slice(last)));
}

function renderMarkdown(host, text) {
  clear(host);
  var blocks = String(text).replace(/\r\n/g, '\n').split(/\n{2,}/);
  for (var b = 0; b < blocks.length; b++) {
    var lines = blocks[b].split('\n').filter(function (l) { return l.trim() !== ''; });
    if (!lines.length) continue;
    if (lines.every(function (l) { return /^\s*[-*]\s+/.test(l); })) {
      var ul = el('ul');
      for (var i = 0; i < lines.length; i++) {
        var li = el('li');
        inlineInto(li, lines[i].replace(/^\s*[-*]\s+/, ''));
        add(ul, li);
      }
      add(host, ul);
    } else {
      var p = el('p');
      inlineInto(p, lines.join(' '));
      add(host, p);
    }
  }
}

/* ---- state ---- */

var launcher = document.getElementById('brassboy-launcher');
if (launcher) launcher.hidden = false;
if (!launcher) return;
var panel = null, logEl = null, liveEl = null, inputEl = null, sendEl = null;
var statusEl = null, chipsEl = null;
var started = false, busy = false, resting = false;
var sessionId = ss(SID_KEY) || null;
var lastFocus = null;

/* ---- panel ---- */

function icon(d) {
  var svg = attr(document.createElementNS(SVGNS, 'svg'),
    { viewBox: '0 0 16 16', width: '15', height: '15', 'aria-hidden': 'true' });
  add(svg, attr(document.createElementNS(SVGNS, 'path'),
    { d: d, stroke: 'currentColor', 'stroke-width': '1.6', fill: 'none' }));
  return svg;
}

function buildPanel() {
  panel = attr(el('div', 'bb-panel'), { role: 'dialog', 'aria-label': t('title') || 'BrassBoy' });
  panel.id = 'brassboy-panel';

  var head = el('div', 'bb-head'), htext = add(head, el('div', 'bb-head__text'));
  add(htext, el('span', 'bb-head__eyebrow', t('eyebrow')));
  add(htext, el('p', 'bb-head__title', t('title')));
  var close = attr(el('button', 'bb-close'), { type: 'button', 'aria-label': t('close') });
  add(close, icon('M3 3l10 10M13 3L3 13'));
  close.addEventListener('click', function () { closePanel(); });
  add(head, close);
  add(panel, head);

  logEl = add(panel, el('div', 'bb-log'));
  logEl.id = 'brassboy-log';
  liveEl = attr(add(panel, el('div', 'bb-sr')), { 'aria-live': 'polite' });

  var composer = el('div', 'bb-composer');
  inputEl = attr(document.createElement('textarea'), { rows: '1', 'aria-label': t('placeholder'), placeholder: t('placeholder') });
  inputEl.maxLength = MAX_MESSAGE;
  inputEl.addEventListener('input', autoGrow);
  inputEl.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && !ev.shiftKey) { ev.preventDefault(); submitTurn(); }
  });
  add(composer, inputEl);
  sendEl = attr(el('button', 'bb-send', t('send')), { type: 'button' });
  sendEl.addEventListener('click', function () { submitTurn(); });
  add(composer, sendEl);
  add(panel, composer);
  add(document.body, panel);
  panel.addEventListener('keydown', onPanelKeydown);
}

function autoGrow() {
  inputEl.style.height = 'auto';
  inputEl.style.height = Math.min(inputEl.scrollHeight, 110) + 'px';
}

function focusables() {
  var sel = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled])';
  return Array.prototype.filter.call(panel.querySelectorAll(sel), function (n) {
    return n.offsetParent !== null || n === document.activeElement;
  });
}

function onPanelKeydown(ev) {
  if (ev.key === 'Escape') { ev.stopPropagation(); closePanel(); return; }
  if (ev.key !== 'Tab') return;
  var list = focusables();
  if (!list.length) return;
  var first = list[0], last = list[list.length - 1];
  if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
  else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
}

function openPanel() {
  if (!panel) buildPanel();
  lastFocus = document.activeElement;
  panel.classList.add('bb-open');
  launcher.setAttribute('aria-expanded', 'true');
  ssSet(OPEN_KEY, '1');
  syncLauncher();
  if (!started) { started = true; startSession(); }
  window.setTimeout(function () { if (inputEl) inputEl.focus(); }, 60);
}

function closePanel() {
  if (!panel) return;
  panel.classList.remove('bb-open');
  launcher.setAttribute('aria-expanded', 'false');
  ssDel(OPEN_KEY);
  syncLauncher();
  if (lastFocus && lastFocus.focus) lastFocus.focus(); else launcher.focus();
}

launcher.addEventListener('click', function () {
  if (panel && panel.classList.contains('bb-open')) closePanel(); else openPanel();
});

/* Cart drawer: snippets/cart-drawer.liquid:257 renders <cart-drawer
   id="cart-drawer" data-name="cart-drawer">; assets/side-drawer.js:95 sets
   `open` + aria-hidden="false" and :132 clears them, firing
   on:cart-drawer:after-open / after-close. The launcher hides for it. */

var drawerEl = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
function drawerOpen() {
  return !!(drawerEl && (drawerEl.hasAttribute('open') || drawerEl.getAttribute('aria-hidden') === 'false'));
}
function syncLauncher() {
  launcher.classList.toggle('bb-launcher--away',
    !!(drawerOpen() || (panel && panel.classList.contains('bb-open'))));
}
if (drawerEl) {
  ['before-open', 'after-open', 'after-close'].forEach(function (name) {
    document.addEventListener('on:cart-drawer:' + name, syncLauncher);
  });
  if (window.MutationObserver) {
    new MutationObserver(syncLauncher).observe(drawerEl, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
  }
}
syncLauncher();

/* The launcher is a 36px pill at the bottom left at every width
   (brassboy.css, v2 2026-10-25). When a bottom bar is up (PDP sticky
   add to cart, trade sticky CTA, quote form bar) --bb-lift carries its height
   so the pill rides above it instead of on it. */
var liftBars = '.sticky-atc-panel, .tr4-sticky, .rfq-mobile';
var liftQueued = false;
function liftLauncher() {
  liftQueued = false;
  var h = 0, vh = window.innerHeight;
  var bars = document.querySelectorAll(liftBars);
  for (var i = 0; i < bars.length; i++) {
    var cs = window.getComputedStyle(bars[i]);
    if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) continue;
    var r = bars[i].getBoundingClientRect();
    /* Docked in the lower half (the PDP panel floats 20px off the edge). */
    if (r.height && r.top < vh && r.top > vh / 2) h = Math.max(h, vh - r.top);
  }
  launcher.style.setProperty('--bb-lift', Math.round(h) + 'px');
}
var liftSettle = null;
function queueLift() {
  /* The bars slide in and out on scroll, so measure again once the slide ends. */
  window.clearTimeout(liftSettle);
  liftSettle = window.setTimeout(liftLauncher, 400);
  if (liftQueued) return;
  liftQueued = true;
  window.requestAnimationFrame(liftLauncher);
}
window.addEventListener('scroll', queueLift, { passive: true });
window.addEventListener('resize', queueLift);
liftLauncher();

/* ---- transcript ---- */

function scroll() { logEl.scrollTop = logEl.scrollHeight; }
function addUser(text) { var d = el('div', 'bb-msg bb-msg--you', text); logEl.appendChild(d); scroll(); return d; }
function addBot() { var d = el('div', 'bb-msg bb-msg--bot'); logEl.appendChild(d); scroll(); return d; }
function addError(text) { logEl.appendChild(el('div', 'bb-error', text)); scroll(); }

function setStatus(text) {
  if (!statusEl) statusEl = el('div', 'bb-status');
  clear(statusEl);
  if (!text) { if (statusEl.parentNode) statusEl.parentNode.removeChild(statusEl); return; }
  add(statusEl, txt(text));
  add(logEl, statusEl);
  scroll();
}

function say(text) {
  if (!liveEl || !text) return;
  add(liveEl, el('p', null, text));
  while (liveEl.childNodes.length > 6) liveEl.removeChild(liveEl.firstChild);
}

function setChips(list) {
  if (chipsEl && chipsEl.parentNode) chipsEl.parentNode.removeChild(chipsEl);
  chipsEl = null;
  if (!list || !list.length) return;
  chipsEl = el('div', 'bb-chips');
  list.forEach(function (raw) {
    var label = String(raw);
    var b = el('button', 'bb-chip', label);
    b.type = 'button';
    b.addEventListener('click', function () {
      if (busy) return;
      inputEl.value = label;
      submitTurn();
    });
    add(chipsEl, b);
  });
  add(logEl, chipsEl);
  scroll();
}

function lock(on) {
  busy = on;
  if (sendEl) sendEl.disabled = on;
  if (inputEl) inputEl.disabled = on;
}

function showResting(message, quoteUrl) {
  var c = card(t('resting_title'), null), body = bodyOf(c);
  if (message) body.appendChild(el('p', 'bb-card__note', message));
  var actions = el('div', 'bb-actions');
  add(actions, link(quoteUrl || QUOTE_URL, t('quote_cta'), 'bb-btn bb-btn--primary'));
  add(actions, link(CONTACT_URL, t('contact_cta'), 'bb-btn bb-btn--ghost'));
  add(body, actions);
  add(logEl, c);
  resting = true;
  lock(true);
  scroll();
}

/* ---- page and cart context ---- */

function cartContext() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return null;
      return {
        item_count: cart.item_count,
        total_cents: cart.total_price,
        items: (cart.items || []).slice(0, 20).map(function (i) {
          return {
            variant_id: i.variant_id, handle: i.handle,
            title: i.product_title || i.title, quantity: i.quantity,
            properties: i.properties || {}
          };
        })
      };
    })
    .catch(function () { return null; });
}

function pageContext(cart) {
  var p = CFG.page || {};
  return {
    type: p.type || 'other', url: p.url || window.location.href, lang: LANG,
    product_handle: p.product_handle || null, product_title: p.product_title || null,
    product_id: p.product_id || null, template_suffix: p.template_suffix || null,
    collection_handle: p.collection_handle || null, query: p.query || null,
    cart: cart || null
  };
}

/* ---- session ---- */

function startSession() {
  setStatus(t('working'));
  lock(true);
  cartContext().then(function (cart) {
    return fetch(HOST + '/api/session', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lang: LANG, page: pageContext(cart) })
    });
  }).then(function (r) {
    if (!r.ok) throw new Error('session ' + r.status);
    return r.json();
  }).then(function (data) {
    setStatus('');
    if (data.resting) { showResting(data.message, data.quote_url); return; }
    sessionId = data.session_id || null;
    if (sessionId) ssSet(SID_KEY, sessionId);
    if (data.greeting) { renderMarkdown(addBot(), data.greeting); say(data.greeting); }
    setChips(data.chips || []);
    lock(false);
    if (inputEl) inputEl.focus();
  }).catch(function () {
    setStatus('');
    addError(t('err_network'));
    lock(false);
  });
}

/* ---- a turn ---- */

function submitTurn() {
  if (busy || resting || !inputEl) return;
  var text = inputEl.value.trim();
  if (!text) return;
  if (text.length > MAX_MESSAGE) { addError(t('err_long')); return; }
  if (!sessionId) { addError(t('err_session')); return; }

  inputEl.value = '';
  autoGrow();
  setChips(null);
  addUser(text);
  lock(true);
  setStatus(t('working'));

  var bot = null, buffer = '';

  function onEvent(type, data) {
    if (type === 'text_delta') {
      setStatus('');
      if (!bot) bot = addBot();
      buffer += (data && data.text) || '';
      renderMarkdown(bot, buffer);
      scroll();
    } else if (type === 'progress') {
      setStatus((data && data.message) || t('working'));
    } else if (type === 'tool_call') {
      if (data && data.label) setStatus(data.label);
    } else if (type === 'ui') {
      setStatus('');
      if (data && data.component === 'suggestions') setChips((data.payload && data.payload.suggestions) || []);
      else if (data) renderCard(data.component, data.payload || {});
      bot = null; buffer = '';
    } else if (type === 'error') {
      setStatus('');
      addError((data && data.message) || t('err_generic'));
    } else if (type === 'turn_complete') {
      setStatus('');
      if (buffer) say(buffer);
    }
    /* ui_partial, tool_result, cart_update, change_update: ignored on
       purpose. A partial would rewrite a card mid-stream for no gain on a
       400 px rail, and the cart is off. */
  }

  cartContext().then(function (cart) {
    return fetch(HOST + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Session-Id': sessionId },
      body: JSON.stringify({ message: text, page: pageContext(cart) })
    });
  }).then(function (res) {
    if (res.status === 401) { ssDel(SID_KEY); sessionId = null; throw new Error('session'); }
    if (res.status === 413) throw new Error('long');
    if (res.status === 429) throw new Error('busy');
    if (res.status === 503) throw new Error('resting');
    if (!res.ok || !res.body || !res.body.getReader) throw new Error('generic');
    return readStream(res, onEvent);
  }).then(function () {
    setStatus('');
    lock(false);
    if (inputEl) inputEl.focus();
  }).catch(function (err) {
    setStatus('');
    var code = err && err.message;
    if (code === 'resting') { showResting('', QUOTE_URL); return; }
    if (code === 'session') addError(t('err_session'));
    else if (code === 'long') addError(t('err_long'));
    else if (code === 'busy') addError(t('err_busy'));
    else addError(t('err_network'));
    lock(false);
  });
}

/* SSE frames as commerce_common.streaming.to_sse writes them:
   "event: <type>\ndata: <json>\n\n". */
function readStream(res, onEvent) {
  var reader = res.body.getReader(), decoder = new TextDecoder(), buf = '';

  function frame(text) {
    var lines = text.split('\n'), type = '', payload = '';
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].indexOf('event:') === 0) type = lines[i].slice(6).trim();
      else if (lines[i].indexOf('data:') === 0) payload += (payload ? '\n' : '') + lines[i].slice(5).replace(/^ /, '');
    }
    if (!type) return;
    var data = null;
    if (payload) { try { data = JSON.parse(payload); } catch (e) { data = null; } }
    try { onEvent(type, data); } catch (e) { /* one bad card never kills the stream */ }
  }

  function pump() {
    return reader.read().then(function (chunk) {
      if (chunk.done) {
        buf = (buf + decoder.decode()).replace(/\r\n/g, '\n');
        if (buf.trim()) frame(buf.trim());
        return;
      }
      buf = (buf + decoder.decode(chunk.value, { stream: true })).replace(/\r\n/g, '\n');
      var idx;
      while ((idx = buf.indexOf('\n\n')) >= 0) { frame(buf.slice(0, idx)); buf = buf.slice(idx + 2); }
      return pump();
    });
  }
  return pump();
}

/* ---- cards ---- */

function card(eyebrow, tag) {
  var c = el('div', 'bb-card'), bar = el('div', 'bb-card__bar');
  add(bar, el('span', 'bb-card__eyebrow', eyebrow || ''));
  if (tag) bar.appendChild(el('span', 'bb-card__tag', tag));
  add(c, bar);
  add(c, el('div', 'bb-card__body'));
  return c;
}
function bodyOf(c) { return c.querySelector('.bb-card__body'); }

function row(parent, label, value, cls) {
  var r = el('div', 'bb-row' + (cls ? ' ' + cls : ''));
  add(r, el('span', 'bb-row__label', label));
  var v = el('span', 'bb-row__value');
  add(v, value instanceof Node ? value : txt(String(value)));
  add(r, v);
  add(parent, r);
  return r;
}

function renderCard(component, payload) {
  var makers = {
    cut_price: cutCard, quote_form: quoteCard, handoff: handoffCard, sizes: sizesCard,
    shipping_estimate: shippingCard, stock_check: stockCard, quote_status: quoteStatusCard,
    products: productsCard, comparison: comparisonCard, guide: guideCard,
    plan: planCard, disclosure: disclosureCard
  };
  var make = makers[component];
  if (!make) return;
  var node = make(payload);
  if (!node) return;
  add(logEl, node);
  scroll();
}

/* ---- 6.1 cut_price ---- */

function normalizeLadder(raw) {
  var out = [];
  (raw || []).forEach(function (r) {
    var q = Number(r.min_qty), d = Number(r.discount_pct);
    if (isFinite(q) && q > 0 && isFinite(d) && d > 0) out.push({ min_qty: q, discount_pct: d });
  });
  return out.sort(function (a, b) { return a.min_qty - b.min_qty; });
}

function cutCard(p) {
  var c = card(t('cut_eyebrow'), null), body = bodyOf(c);
  add(body, el('p', 'bb-card__title', p.title || ''));

  if (p.kind === 'sheet') {
    add(body, el('p', 'bb-card__note bb-card__note--warm', t('cut_sheet')));
    var sa = el('div', 'bb-actions');
    add(sa, link(p.configurator_url || p.url, t('cut_open_product'), 'bb-btn bb-btn--primary'));
    add(body, sa);
    return c;
  }

  var ladder = normalizeLadder(p.ladder);
  var unitBefore = Number(p.unit_price_before_ladder);
  if (!isFinite(unitBefore) || unitBefore <= 0) unitBefore = Number(p.unit_price) || 0;
  var pieces = Math.max(1, parseInt(p.pieces, 10) || 1);

  var rows = el('div', 'bb-rows');
  row(rows, t('cut_length'), fmtIn(p.snapped_length_in != null ? p.snapped_length_in : p.requested_length_in));

  var step = el('div', 'bb-step');
  var minus = el('button', 'bb-step__btn', '−');
  var val = document.createElement('input');
  var plus = el('button', 'bb-step__btn', '+');
  minus.type = plus.type = 'button';
  val.className = 'bb-step__val';
  val.type = 'text';
  val.inputMode = 'numeric';
  val.value = String(pieces);
  [minus, val, plus].forEach(function (n) { n.setAttribute('aria-label', t('cut_pieces')); step.appendChild(n); });
  row(rows, t('cut_pieces'), step);

  var eachVal = row(rows, t('cut_each'), '').querySelector('.bb-row__value');
  var totalVal = row(rows, t('cut_total'), '', 'bb-row--total').querySelector('.bb-row__value');
  add(body, rows);

  body.appendChild(el('p', 'bb-card__note',
    t('cut_billed', { snapped: fmtIn(p.snapped_length_in), billed: fmtIn(p.billed_length_in) }) + ' ' + t('cut_tolerance')));

  var ladderBox = null;
  if (ladder.length) {
    ladderBox = el('div', 'bb-ladder');
    add(ladderBox, el('p', 'bb-ladder__title', t('cut_ladder')));
    ladder.forEach(function (tier) {
      ladderBox.appendChild(el('p', 'bb-ladder__row',
        t('cut_ladder_row', { qty: tier.min_qty, pct: tier.discount_pct })));
    });
    add(body, ladderBox);
  }

  var nextNote = el('p', 'bb-card__note');
  add(body, nextNote);
  add(body, el('p', 'bb-card__note', t('cut_min')));
  if (p.max_length_in) body.appendChild(el('p', 'bb-card__note', t('cut_max', { max: fmtIn(p.max_length_in) })));
  if (p.available === false) body.appendChild(el('p', 'bb-card__note bb-card__note--warm', t('cut_unavailable')));
  (p.notes || []).forEach(function (n) { body.appendChild(el('p', 'bb-card__note', String(n))); });

  var actions = el('div', 'bb-actions');
  var addBtn = el('button', 'bb-btn bb-btn--primary', t('cut_add'));
  addBtn.type = 'button';
  if (p.available === false || !p.variant_id) addBtn.disabled = true;
  add(actions, addBtn);
  add(actions, link(p.url, t('cut_open_product'), 'bb-btn bb-btn--ghost'));
  add(body, actions);

  /* Same arithmetic as api/pricing.py: discount on the pre-ladder unit
     price, rounded to the cent, then multiplied. */
  function tierFor(qty) {
    var best = null;
    ladder.forEach(function (tier) { if (qty >= tier.min_qty) best = tier; });
    return best;
  }
  function nextTierFor(qty) {
    for (var k = 0; k < ladder.length; k++) if (qty < ladder[k].min_qty) return ladder[k];
    return null;
  }
  function unitAt(qty) {
    var tier = tierFor(qty), d = tier ? Number(tier.discount_pct) / 100 : 0;
    return Math.round(unitBefore * (1 - d) * 100) / 100;
  }
  function paint() {
    var unit = unitAt(pieces);
    setText(eachVal, fmtMoney(unit));
    setText(totalVal, fmtMoney(Math.round(unit * pieces * 100) / 100));
    val.value = String(pieces);
    minus.disabled = pieces <= 1;
    clear(nextNote);
    var on = tierFor(pieces), nxt = nextTierFor(pieces);
    if (on) nextNote.appendChild(txt(t('cut_active', { pct: on.discount_pct })));
    else if (nxt) nextNote.appendChild(txt(
      t('cut_next', { n: nxt.min_qty - pieces, price: fmtMoney(unitAt(nxt.min_qty)) })));
    if (ladderBox) {
      var rowsL = ladderBox.querySelectorAll('.bb-ladder__row');
      for (var k = 0; k < rowsL.length; k++) rowsL[k].classList.toggle('is-on', !!on && ladder[k].min_qty === on.min_qty);
    }
  }
  minus.addEventListener('click', function () { if (pieces > 1) { pieces -= 1; paint(); } });
  plus.addEventListener('click', function () { if (pieces < 999) { pieces += 1; paint(); } });
  val.addEventListener('change', function () {
    var v = parseInt(val.value, 10);
    pieces = (isFinite(v) && v >= 1) ? Math.min(v, 999) : 1;
    paint();
  });
  paint();
  addBtn.addEventListener('click', function () { addToCart(p, pieces, addBtn, body); });
  return c;
}

/* Add to cart the theme's way: assets/dynamic-pricing.js:1075-1135.
   renderContents is assets/cart-drawer.js:278. sections_url is the current
   path, matching the theme's live call (SPEC 6.1 writes "/"). */
function addToCart(p, pieces, btn, body) {
  var drawer = document.querySelector('cart-drawer');
  var sections = 'cart-icon-bubble';
  if (drawer && drawer.closest) {
    var sec = drawer.closest('.shopify-section');
    if (sec && sec.id) sections += ',' + sec.id.replace('shopify-section-', '');
  }
  var props = {};
  props['Your Cut'] = p.your_cut || fmtIn(p.snapped_length_in);
  /* Hidden line property (the underscore keeps it off the cart and checkout,
     snippets/cart-items.liquid:198), so orders that came through the chat can be
     counted. Nothing about the customer rides on it. */
  props['_brassboy'] = '1';

  btn.disabled = true;
  setText(btn, t('cut_adding'));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [{ id: p.variant_id, quantity: pieces, properties: props }],
      sections: sections,
      sections_url: window.location.pathname
    })
  }).then(function (r) {
    if (!r.ok) throw new Error('add');
    return r.json();
  }).then(function (data) {
    setText(btn, t('cut_added'));
    btn.classList.add('is-done');
    say(t('cut_added'));
    if (window.ProductForm && window.ProductForm.updateCartIcon) {
      try { window.ProductForm.updateCartIcon(data); } catch (e) { /* icon only */ }
    }
    var after = (window.theme && window.theme.settings && window.theme.settings.afterAtc) || 'drawer';
    if (after === 'page') { window.location.href = CART_URL; return; }
    if (drawer && drawer.renderContents && data.sections) {
      var openIt = after === 'drawer' || (after === 'drawer_desktop' && window.matchMedia('(min-width: 768px)').matches);
      try { drawer.renderContents(data, openIt); } catch (e) { /* drawer refused */ }
      syncLauncher();
    } else if (!drawer) {
      var a = el('div', 'bb-actions');
      add(a, link(CART_URL, t('cut_view_cart'), 'bb-btn bb-btn--ghost'));
      add(body, a);
    }
  }).catch(function () {
    btn.disabled = false;
    btn.classList.remove('is-done');
    setText(btn, t('cut_add'));
    add(body, el('p', 'bb-card__note bb-card__note--warm', t('cut_add_failed')));
  });
}

/* ---- 6.2 quote_form ---- */

function field(label, control, required) {
  var f = el('div', 'bb-field'), lab = el('label', 'bb-field__label', label);
  if (required) lab.appendChild(el('span', 'bb-field__req', '*'));
  control.id = 'bb-f-' + Math.random().toString(36).slice(2, 9);
  lab.htmlFor = control.id;
  add(f, control);
  add(f, lab);
  return f;
}
function input(type, autocomplete) {
  var i = document.createElement('input');
  i.type = type || 'text';
  if (autocomplete) i.autocomplete = autocomplete;
  return i;
}
function select(options, value) {
  var s = document.createElement('select');
  options.forEach(function (o) {
    var opt = document.createElement('option');
    opt.value = o[0];
    add(opt, txt(o[1]));
    if (o[0] === value) opt.selected = true;
    add(s, opt);
  });
  return s;
}
function checkbox(labelText, href, linkText, tail) {
  var wrap = el('label', 'bb-check'), box = document.createElement('input');
  box.type = 'checkbox';
  add(wrap, box);
  var span = el('span', null, labelText);
  if (href) {
    add(span, txt(' '));
    var a = el('a', null, linkText);
    a.href = safeUrl(href) || QUOTE_URL;
    a.target = '_blank';
    a.rel = 'noopener';
    add(span, a);
    if (tail) span.appendChild(txt(' ' + tail));
  }
  add(wrap, span);
  wrap.bbInput = box;
  return wrap;
}
function optional(key) { return t(key) + ' (' + t('qf_optional') + ')'; }
function provinceOptions() {
  var out = [['', t('qf_pick')]];
  String(S.qf_provinces || '').split(';').forEach(function (raw) {
    if (!raw) return;
    var parts = raw.split('|');
    out.push([parts[0], parts[1] || parts[0]]);
  });
  return out;
}
function axisMeta(line, key) {
  var req = line.required_axes || [];
  for (var i = 0; i < req.length; i++) {
    if (req[i].key === key) {
      return { key: key, label: (LANG === 'fr' && req[i].label_fr) ? req[i].label_fr : (req[i].label || key) };
    }
  }
  return { key: key, label: String(key).replace(/_/g, ' ') };
}

/* The model's lines, any axis still missing shown as an input. */
function quoteLines(body, lines, axisInputs) {
  if (!lines.length) return;
  add(body, el('p', 'bb-block__sub', t('qf_lines')));
  lines.forEach(function (line, idx) {
    var box = el('div', 'bb-line');
    var title = line.title || [line.grade, line.material, line.shape].filter(Boolean).join(' ');
    add(box, el('p', 'bb-line__title', title || t('qf_lines')));
    var bits = [];
    if (line.length_in) bits.push(t('qf_length') + ' ' + fmtIn(line.length_in));
    if (line.quantity) bits.push(t('qf_qty') + ' ' + line.quantity);
    if (bits.length) box.appendChild(el('p', 'bb-line__meta', bits.join(' · ')));
    var missing = line.missing_axes || [];
    if (missing.length) {
      var grid = el('div', 'bb-grid2');
      missing.forEach(function (key) {
        var axis = axisMeta(line, key), ctl = input('text');
        add(grid, field(axis.label, ctl, true));
        axisInputs.push({ lineIndex: idx, key: axis.key, label: axis.label, control: ctl });
      });
      add(box, grid);
    }
    add(body, box);
  });
}

function quoteCard(p) {
  var c = card(t('qf_title'), null), body = bodyOf(c);
  add(body, el('p', 'bb-card__note', t('qf_intro')));

  var lines = p.lines || [], axisInputs = [], F = {};
  quoteLines(body, lines, axisInputs);

  /* [state key, label, control, required, row group] */
  F.first = input('text', 'given-name');
  F.last = input('text', 'family-name');
  F.email = input('email', 'email');
  F.phone = input('tel', 'tel');
  F.status = select([['New', t('qf_status_new')], ['Returning', t('qf_status_ret')]], 'New');
  F.province = select(provinceOptions(), '');
  F.fulfil = select([['pickup', t('qf_pickup')], ['include_shipping', t('qf_ship')], ['cod_shipping', t('qf_cod')]],
    p.fulfillment_method || 'pickup');
  F.line1 = input('text', 'address-line1');
  F.line2 = input('text');
  F.city = input('text', 'address-level2');
  F.postal = input('text', 'postal-code');
  F.notes = document.createElement('textarea');
  if (p.notes) F.notes.value = String(p.notes);

  var form = el('div', 'bb-form');
  function pair(a, b) {
    var g = el('div', 'bb-grid2');
    add(g, a);
    add(g, b);
    return g;
  }
  add(form, pair(field(t('qf_first'), F.first, true), field(t('qf_last'), F.last, true)));
  add(form, pair(field(t('qf_email'), F.email, true), field(optional('qf_phone'), F.phone, false)));
  add(form, pair(field(t('qf_status'), F.status, true), field(t('qf_province'), F.province, true)));
  add(form, field(t('qf_fulfil'), F.fulfil, true));

  /* address_line_1 is required for include_shipping and cod_acknowledgement
     for cod_shipping: scripts/sm3-dashboard/lib/rfq-ingest.js:130-135. */
  var addr = el('div', 'bb-form');
  addr.hidden = true;
  add(addr, field(t('qf_address'), F.line1, true));
  add(addr, field(optional('qf_address2'), F.line2, false));
  add(addr, pair(field(t('qf_city'), F.city, true), field(t('qf_postal'), F.postal, true)));
  add(form, addr);

  var codAck = checkbox(t('qf_cod_ack'));
  codAck.hidden = true;
  add(form, codAck);
  F.fulfil.addEventListener('change', function () {
    addr.hidden = F.fulfil.value !== 'include_shipping';
    codAck.hidden = F.fulfil.value !== 'cod_shipping';
  });

  add(form, field(optional('qf_notes'), F.notes, false));
  var cert = checkbox(t('qf_cert'));
  if (p.cert_requirement && p.cert_requirement !== 'None') cert.bbInput.checked = true;
  add(form, cert);
  var terms = checkbox(t('qf_terms_pre'), '/policies/terms-of-service', t('qf_terms_link'), t('qf_terms_post'));
  add(form, terms);

  var errBox = el('div', 'bb-error');
  errBox.hidden = true;
  add(form, errBox);
  var submit = el('button', 'bb-btn bb-btn--primary', t('qf_submit'));
  submit.type = 'button';
  var actions = el('div', 'bb-actions');
  add(actions, submit);
  add(form, actions);
  add(body, form);

  function fail(text, offerPage) {
    clear(errBox).appendChild(txt(text));
    if (offerPage) {
      var qa = el('div', 'bb-actions');
      add(qa, link(QUOTE_URL, t('qf_quote_page'), 'bb-btn bb-btn--ghost'));
      add(errBox, qa);
    }
    errBox.hidden = false;
    submit.disabled = false;
    setText(submit, t('qf_submit'));
  }

  submit.addEventListener('click', function () {
    errBox.hidden = true;
    var v = {};
    ['first', 'last', 'email', 'phone', 'line1', 'line2', 'city', 'postal', 'notes'].forEach(function (k) {
      v[k] = F[k].value.trim();
    });
    v.postal = v.postal.toUpperCase();
    v.status = F.status.value;
    v.province = F.province.value;
    v.fulfil = F.fulfil.value;
    v.cod = codAck.bbInput.checked;
    v.cert = cert.bbInput.checked;

    var bad = [];
    if (!v.first) bad.push(t('qf_first'));
    if (!v.last) bad.push(t('qf_last'));
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) bad.push(t('qf_email'));
    if (!v.province) bad.push(t('qf_province'));
    if (!terms.bbInput.checked) bad.push(t('qf_terms_link'));
    if (v.fulfil === 'include_shipping' && !v.line1) bad.push(t('qf_address'));
    if (v.fulfil === 'cod_shipping' && !v.cod) bad.push(t('qf_cod'));
    axisInputs.forEach(function (a) { if (!a.control.value.trim()) bad.push(a.label); });
    if (bad.length) { fail(t('qf_err_title') + ': ' + bad.join(', '), false); return; }

    submit.disabled = true;
    setText(submit, t('qf_sending'));
    fetch(p.submit_url || RFQ_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildQuotePayload(p, lines, axisInputs, v))
    }).then(function (r) {
      return r.text().then(function (txt) {
        var parsed = null;
        try { parsed = JSON.parse(txt); } catch (e) { parsed = null; }
        return { ok: r.ok, status: r.status, body: parsed };
      });
    }).then(function (res) {
      if (res.ok && res.body && res.body.reference_number) { quoteDone(c, res.body); return; }
      var detail = res.body && (res.body.errors || res.body.error || res.body.detail);
      if (res.status === 422 && detail) {
        fail(t('qf_err_title') + ': ' + (Array.isArray(detail) ? detail.join('; ') : String(detail)), true);
      } else {
        fail(t('qf_err_generic'), true);
      }
    }).catch(function () { fail(t('qf_err_generic'), true); });
  });

  return c;
}


/* Schema 3.2.0 as assets/rfq-form.js:2421-2462 builds it, submitted_from
   "brassboy". A catalog line earns 3.2.0 only with the v2 required_axes
   contract; otherwise 3.1.0 keeps the backend lenient, the same vote
   rfq-form.js:2405-2417 makes. */
function buildQuotePayload(p, lines, axisInputs, c) {
  var allV2 = true, items = [];

  lines.forEach(function (line, i) {
    var mode = line.mode || 'catalog', dims = {}, k;
    if (line.dimensions) {
      for (k in line.dimensions) {
        if (Object.prototype.hasOwnProperty.call(line.dimensions, k)) dims[k] = line.dimensions[k];
      }
    }
    axisInputs.forEach(function (a) { if (a.lineIndex === i) dims[a.key] = a.control.value.trim(); });
    var lenN = Number(line.length_in);
    var hasLen = isFinite(lenN) && lenN > 0;
    if (hasLen) dims.length = lenN;

    if (mode === 'freeform') {
      items.push({
        mode: 'freeform', freeform_text: String(line.notes || line.title || '').trim(),
        quantity: line.quantity || 1, is_specialty_freight: false, is_always_raq: false,
        customer_unsure_fields: [], matched_product_id: line.matched_product_id || null
      });
      return;
    }
    if (mode === 'sourcing') {
      items.push({
        mode: 'sourcing', material: line.material || '', shape: line.shape || '',
        grade: line.grade || '',
        dimensions: { text: dimText(dims), length: hasLen ? lenN : null },
        quantity: line.quantity || 1, sourcing_description: line.notes || null,
        sourcing_files: [], is_specialty_freight: false, is_always_raq: false,
        customer_unsure_fields: [], matched_product_id: null
      });
      return;
    }
    if (!line.required_axes || !line.required_axes.length) allV2 = false;
    items.push({
      mode: 'catalog', material: line.material || '', shape: line.shape || '',
      grade: line.grade || '', dimensions: dims, quantity: line.quantity || 1,
      sourcing_description: null, sourcing_files: [], is_specialty_freight: false,
      is_always_raq: false, customer_unsure_fields: [],
      matched_product_id: line.matched_product_id || null, sku: null,
      handle: line.matched_handle || null, product_title: line.title || null
    });
  });

  var payload = {
    schema_version: allV2 ? '3.2.0' : '3.1.0',
    submitted_from: 'brassboy',
    was_authenticated: false,
    lang: p.lang || LANG,
    email: c.email, first_name: c.first, last_name: c.last, phone: c.phone,
    customer_status: c.status || 'New',
    business_name: '',
    ship_to_province: c.province,
    timeline: '', specific_date: '',
    fulfillment_method: c.fulfil,
    cert_requirement: c.cert ? 'Mill cert' : (p.cert_requirement || 'None'),
    recurring: false,
    additional_notes: [p.notes || '', c.notes || ''].filter(Boolean).join('\n').trim(),
    terms_accepted: true,
    terms_accepted_at: new Date().toISOString(),
    promotional_consent: false,
    line_items: items
  };
  if (p.reason) payload.quote_reason = p.reason;
  if (c.fulfil === 'include_shipping') {
    payload.shipping_address = {
      first_name: c.first, last_name: c.last, company: '',
      address_line_1: c.line1, address_line_2: c.line2,
      city: c.city, province: c.province, postal_code: c.postal, country: 'Canada'
    };
  }
  if (c.fulfil === 'cod_shipping') payload.cod_acknowledgement = true;
  return payload;
}

function dimText(dims) {
  var parts = [];
  for (var k in dims) {
    if (!Object.prototype.hasOwnProperty.call(dims, k) || k === 'length') continue;
    if (dims[k] === null || dims[k] === '') continue;
    parts.push(k.replace(/_/g, ' ') + ' ' + dims[k]);
  }
  return parts.join(', ');
}

function reportQuoteReference(reference) {
  /* Joins the quote to its transcript in MRU Online. Best effort: a miss here
     changes nothing the customer sees. */
  if (!HOST || !sessionId || !reference) return;
  try {
    fetch(HOST + '/api/quote-reference', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Session-Id': sessionId },
      body: JSON.stringify({ reference_number: String(reference) })
    }).catch(function () { /* best effort */ });
  } catch (e) { /* best effort */ }
}

function quoteDone(c, body) {
  reportQuoteReference(body.reference_number);
  var target = clear(bodyOf(c));
  add(target, el('p', 'bb-card__title', t('qf_done_title')));
  var rows = el('div', 'bb-rows');
  row(rows, t('qf_done_ref'), String(body.reference_number));
  add(target, rows);
  add(target, el('p', 'bb-card__note', t('qf_done_body')));
  if (body.status_url && safeUrl(body.status_url)) {
    var a = el('div', 'bb-actions');
    add(a, link(body.status_url, t('qf_track'), 'bb-btn bb-btn--ghost'));
    add(target, a);
  }
  say(t('qf_done_title'));
  scroll();
}

/* ---- 6.3 handoff ---- */

function mailto(addr) { var a = el('a', null, addr); a.href = 'mailto:' + String(addr); return a; }
function tel(num) { var a = el('a', null, String(num)); a.href = 'tel:' + String(num).replace(/[^0-9+]/g, ''); return a; }

/* The customer-service inquiry the handoff posts: the same public endpoint the
   customer-service page uses (scripts/sm3-dashboard/routes/public-rfq.js
   /customer-service/submit), which lands with the sales team. The topic list is
   lib/customer-service-ingest.js TOPICS. */
var CS_URL = 'https://rfq.metalsrus.ca/customer-service/submit';
var CS_TOPICS = {
  order_status: 'Order question (existing or recent)',
  order_change: 'Order question (existing or recent)',
  cancel: 'Order question (existing or recent)',
  'return': 'Returns or replacements',
  damage: 'Shipping or pickup status',
  lost: 'Shipping or pickup status',
  missing: 'Shipping or pickup status',
  billing: 'Billing or invoice',
  account: 'Account or login issue',
  trade_account: 'Wholesale / business inquiry',
  cert: 'Product question (no quote needed)',
  plasma: 'Product question (no quote needed)',
  secondary_ops: 'Product question (no quote needed)',
  other: 'Something else'
};

/* Before 2026-09-22 this card was contact rows only: the summary the assistant
   wrote went to nobody and the customer started over in an email. Now it takes a
   name and an email and sends the summary, with a link to the conversation, to the
   team. */
function handoffForm(p, body) {
  var form = el('div', 'bb-form');
  add(form, el('p', 'bb-card__note', t('ho_form_intro')));
  var F = {};
  F.first = input('text', 'given-name');
  F.last = input('text', 'family-name');
  F.email = input('email', 'email');
  F.message = document.createElement('textarea');
  if (p.summary) F.message.value = String(p.summary);
  var g = el('div', 'bb-grid2');
  add(g, field(t('qf_first'), F.first, true));
  add(g, field(t('qf_last'), F.last, true));
  add(form, g);
  add(form, field(t('qf_email'), F.email, true));
  add(form, field(t('ho_message'), F.message, true));
  var errBox = el('div', 'bb-error');
  errBox.hidden = true;
  add(form, errBox);
  var send = el('button', 'bb-btn bb-btn--primary', t('ho_send'));
  send.type = 'button';
  var actions = el('div', 'bb-actions');
  add(actions, send);
  add(form, actions);

  function fail(text) {
    setText(errBox, text);
    errBox.hidden = false;
    send.disabled = false;
    setText(send, t('ho_send'));
  }

  send.addEventListener('click', function () {
    errBox.hidden = true;
    var first = F.first.value.trim(), last = F.last.value.trim(), email = F.email.value.trim();
    var message = F.message.value.trim();
    var bad = [];
    if (!first) bad.push(t('qf_first'));
    if (!last) bad.push(t('qf_last'));
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) bad.push(t('qf_email'));
    if (!message) bad.push(t('ho_message'));
    if (bad.length) { fail(t('qf_err_title') + ': ' + bad.join(', ')); return; }
    send.disabled = true;
    setText(send, t('ho_sending'));
    var tail = [t('ho_from') + (p.reason ? ' (' + String(p.reason).replace(/_/g, ' ') + ')' : '') + '.'];
    if (p.conversation_id) tail.push('Conversation: https://orders.metalsrus.ca/#brassboy/' + String(p.conversation_id));
    tail.push('Page: ' + window.location.href.split('?')[0]);
    fetch(CS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        first_name: first, last_name: last, email: email, phone: '',
        topic: CS_TOPICS[p.reason] || CS_TOPICS.other,
        order_number: '',
        message: message + '\n\n' + tail.join('\n')
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('send');
      return r.json();
    }).then(function () {
      var done = clear(form);
      add(done, el('p', 'bb-card__title', t('ho_sent_title')));
      add(done, el('p', 'bb-card__note', t('ho_sent_body')));
      say(t('ho_sent_title'));
    }).catch(function () { fail(t('ho_err')); });
  });
  add(body, form);
}

function handoffCard(p) {
  var c = card(t('ho_title'), null), body = bodyOf(c);
  if (p.summary) body.appendChild(el('p', 'bb-card__note bb-card__note--warm', p.summary));
  handoffForm(p, body);
  var rows = el('div', 'bb-rows');
  if (p.next_step) row(rows, t('ho_next'), p.next_step);
  if (p.email) row(rows, t('ho_email'), mailto(p.email));
  if (p.phone) row(rows, t('ho_phone'), tel(p.phone));
  if (p.toll_free) row(rows, t('ho_toll'), tel(p.toll_free));
  if (p.hours) row(rows, t('ho_hours'), p.hours);
  add(body, rows);
  var actions = el('div', 'bb-actions');
  if (p.form_url) actions.appendChild(link(p.form_url, t('ho_form'), 'bb-btn bb-btn--primary'));
  if (p.plasma_url) actions.appendChild(link(p.plasma_url, t('ho_plasma'), 'bb-btn bb-btn--ghost'));
  if (p.trade_url) actions.appendChild(link(p.trade_url, t('ho_trade'), 'bb-btn bb-btn--ghost'));
  if (!actions.childNodes.length) actions.appendChild(link(CONTACT_URL, t('contact_cta'), 'bb-btn bb-btn--primary'));
  add(body, actions);
  return c;
}

/* ---- 6.3b sizes ---- */

/* Every stocked size of one shape, from the catalog. Rows link to the product
   page; a tap there prices the cut. */
function sizesCard(p) {
  var rows = p.rows || [];
  var c = card(p.title || t('sz_title'), null), body = bodyOf(c);
  if (!rows.length) {
    add(body, el('p', 'bb-card__note', t('sz_none')));
    return c;
  }
  add(body, el('p', 'bb-card__note', t('sz_intro', { n: p.count || rows.length })));
  var list = el('ul', 'bb-sizes');
  rows.forEach(function (r) {
    var li = el('li', 'bb-sizes__row'), href = safeUrl(r.url);
    var title = el(href ? 'a' : 'span', 'bb-sizes__title', r.title || '');
    if (href) { title.href = href; title.rel = 'noopener'; }
    add(li, title);
    var meta = [];
    if (r.max_length_in) meta.push(t('sz_max', { max: fmtIn(r.max_length_in) }));
    if (r.quote_only) meta.push(t('pc_quote_only'));
    if (meta.length) add(li, el('span', 'bb-sizes__meta', meta.join(' · ')));
    add(list, li);
  });
  add(body, list);
  if (p.count && p.shown && p.count > p.shown) {
    add(body, el('p', 'bb-card__note', t('sz_more', { n: p.count - p.shown })));
  }
  return c;
}

/* ---- 6.3c shipping estimate ---- */

/* The carrier options priced the way checkout prices them. Never a transit
   time: the note says the exact rate shows at checkout. */
function shippingCard(p) {
  var options = p.options || [];
  var c = card(p.title || t('se_title'), null), body = bodyOf(c);
  var where = p.postal ? (p.place ? p.postal + ' (' + p.place + ')' : p.postal) : '';
  if (where) add(body, el('p', 'bb-card__note', t('se_to', { where: where })));
  if (!options.length) {
    add(body, el('p', 'bb-card__note', t('se_none')));
    return c;
  }
  var rows = el('div', 'bb-rows');
  options.forEach(function (o) {
    var label = String(o.name || '') + (o.kind === 'freight' ? ' · ' + t('se_freight') : '');
    row(rows, label, fmtMoney(o.price_cad));
  });
  add(body, rows);
  var bits = [];
  if (p.total_lb && p.pieces) bits.push(t('se_load', { lb: p.total_lb, n: p.pieces }));
  bits.push(t('se_note'));
  add(body, el('p', 'bb-card__note', bits.join(' ')));
  (p.warnings || []).forEach(function (w) { add(body, el('p', 'bb-card__note', String(w))); });
  return c;
}

/* ---- 6.3d stock check ---- */

/* The shop's own rack count from before opening, per product: on the rack or
   not, pieces long enough for the cut, the longest piece, dated to the count.
   Nothing here is a promise: the note says stock moves through the day. */
function stockCard(p) {
  var rows = p.rows || [];
  var c = card(p.title || t('sc_title'), null), body = bodyOf(c);
  if (p.as_of) add(body, el('p', 'bb-card__note', t('sc_as_of', { date: p.as_of })));
  rows.forEach(function (r) {
    var blk = el('div', 'bb-stock');
    var head = el('div', 'bb-stock__head');
    add(head, el('span', 'bb-stock__title', r.title || ''));
    var state = r.in_stock === true ? 'in' : r.in_stock === false ? 'out' : 'unknown';
    add(head, el('span', 'bb-stock__badge bb-stock__badge--' + state,
      state === 'in' ? t('sc_in') : state === 'out' ? t('sc_out') : t('sc_unknown')));
    add(blk, head);
    var meta = [];
    if (r.length_in) meta.push(t('sc_cut', { len: fmtIn(r.length_in), n: r.pieces_wanted || 1 }));
    if (state === 'in' && r.pieces != null) meta.push(r.length_in ? t('sc_pieces_cut', { n: r.pieces }) : t('sc_pieces', { n: r.pieces }));
    if (state === 'in' && r.longest_in) meta.push(t('sc_longest', { len: fmtIn(r.longest_in) }));
    if (state === 'unknown') meta.push(t('sc_unknown_note'));
    if (r.note) meta.push(String(r.note));
    if (meta.length) add(blk, el('p', 'bb-stock__meta', meta.join(' \u00b7 ')));
    add(body, blk);
  });
  add(body, el('p', 'bb-card__note', t('sc_note')));
  return c;
}

/* ---- 6.3e quote status ---- */

/* Where a quote request stands, shown only after the reference and the email
   matched on the quote service. The email never reaches this card. */
function quoteStatusCard(p) {
  var c = card(p.title || t('qs_title'), null), body = bodyOf(c);
  var rows = el('div', 'bb-rows');
  row(rows, t('qf_done_ref'), String(p.reference || ''));
  var st = String(p.status || 'submitted');
  var label = t('qs_st_' + st) || t('qs_' + st) || st;
  row(rows, t('qs_status'), label);
  if (p.submitted_at) row(rows, t('qs_submitted'), fmtDate(p.submitted_at));
  if (p.sent_at) row(rows, t('qs_sent'), fmtDate(p.sent_at));
  if (p.total_cad != null && isFinite(Number(p.total_cad))) row(rows, t('qs_total'), fmtMoney(p.total_cad), 'bb-row--total');
  if (p.valid_until) row(rows, t('qs_valid'), fmtDate(p.valid_until));
  add(body, rows);
  if (p.next_step) add(body, el('p', 'bb-card__note bb-card__note--warm', String(p.next_step)));
  return c;
}

/* A date as the customer reads it, from an ISO stamp or a plain YYYY-MM-DD. */
function fmtDate(raw) {
  var s = String(raw || '');
  var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return s;
  var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  try { return d.toLocaleDateString(LANG === 'fr' ? 'fr-CA' : 'en-CA', { year: 'numeric', month: 'long', day: 'numeric' }); }
  catch (e) { return m[1] + '-' + m[2] + '-' + m[3]; }
}

/* ---- 6.4 built-in cards ---- */

function productTile(product, reason) {
  var attrs = product.attributes || {}, href = safeUrl(attrs.url);
  var tile = el(href ? 'a' : 'div', 'bb-tile');
  if (href) { tile.href = href; tile.rel = 'noopener'; }
  var src = product.image_url ? safeUrl(product.image_url) : null;
  if (src) {
    var img = document.createElement('img');
    img.className = 'bb-tile__img';
    img.src = src;
    img.alt = '';
    img.loading = 'lazy';
    add(tile, img);
  } else {
    add(tile, el('span', 'bb-tile__img'));
  }
  var b = el('div', 'bb-tile__body');
  add(b, el('p', 'bb-tile__title', product.title || ''));
  var meta = el('p', 'bb-tile__meta');
  if (attrs.raq === 'true' || attrs.price_note === 'quote') {
    add(meta, el('span', 'bb-tile__price', t('pc_quote_only')));
  } else if (product.price) {
    add(meta, el('span', 'bb-tile__price', fmtMoney(product.price)));
    if (attrs.price_note) meta.appendChild(txt(' · ' + attrs.price_note));
  }
  add(b, meta);
  if (product.in_stock === false) b.appendChild(el('span', 'bb-tile__badge', t('pc_out')));
  if (reason) b.appendChild(el('p', 'bb-tile__reason', reason));
  add(tile, b);
  return tile;
}

function tileGrid(products) {
  var grid = el('div', 'bb-tiles');
  products.forEach(function (p) { if (p) grid.appendChild(productTile(p, null)); });
  return grid;
}

function productsCard(p) {
  var items = p.items || [];
  if (!items.length) return null;
  var c = card(p.title || t('pc_view'), null), grid = el('div', 'bb-tiles');
  items.forEach(function (it) { if (it && it.product) grid.appendChild(productTile(it.product, it.reason)); });
  bodyOf(c).appendChild(grid);
  return c;
}

function bulletList(parent, label, arr) {
  if (!arr || !arr.length) return;
  add(parent, el('p', 'bb-block__sub', label));
  var ul = el('ul');
  arr.forEach(function (x) { ul.appendChild(el('li', null, String(x))); });
  add(parent, ul);
}

function comparisonCard(p) {
  var entries = p.entries || [];
  if (!entries.length) return null;
  var c = card(p.title || '', null), body = bodyOf(c);
  entries.forEach(function (e) {
    var blk = el('div', 'bb-block'), prod = e.product || {};
    add(blk, el('p', 'bb-block__head', prod.title || e.product_id));
    if (p.recommended_product_id && p.recommended_product_id === e.product_id) {
      add(blk, el('span', 'bb-tile__badge', t('cmp_pick')));
    }
    if (prod.price) blk.appendChild(el('p', null, fmtMoney(prod.price)));
    bulletList(blk, t('cmp_pros'), e.pros);
    bulletList(blk, t('cmp_cons'), e.cons);
    if (e.best_for) {
      add(blk, el('p', 'bb-block__sub', t('cmp_best')));
      add(blk, el('p', null, e.best_for));
    }
    add(body, blk);
  });
  return c;
}

function guideCard(p) {
  var c = card(p.title || '', null), body = bodyOf(c);
  (p.sections || []).forEach(function (s) {
    var blk = el('div', 'bb-block');
    add(blk, el('p', 'bb-block__head', s.heading || ''));
    var wrap = el('div');
    renderMarkdown(wrap, s.body || '');
    add(blk, wrap);
    add(body, blk);
  });
  if ((p.related_products || []).length) body.appendChild(tileGrid(p.related_products));
  sourcesInto(body, p.sources);
  return c;
}

function planCard(p) {
  var c = card(p.title || '', null), body = bodyOf(c);
  if (p.intro) body.appendChild(el('p', 'bb-card__note', p.intro));
  (p.steps || []).forEach(function (s, i) {
    var blk = el('div', 'bb-block');
    add(blk, el('p', 'bb-block__head', (i + 1) + '. ' + (s.label || '')));
    if (s.detail) blk.appendChild(el('p', null, s.detail));
    if ((s.products || []).length) blk.appendChild(tileGrid(s.products));
    add(body, blk);
  });
  return c;
}

function disclosureCard(p) {
  var c = card(p.title || '', null), body = bodyOf(c), rows = el('div', 'bb-rows');
  (p.rows || []).forEach(function (r) {
    var value = el('span', null, String(r.value));
    if (r.note) value.appendChild(el('span', 'bb-row__note', r.note));
    row(rows, r.label, value);
  });
  add(body, rows);
  (p.footnotes || []).forEach(function (n) { body.appendChild(el('p', 'bb-card__note', String(n))); });
  sourcesInto(body, p.sources);
  return c;
}

function sourcesInto(body, sources) {
  if (!sources || !sources.length) return;
  var box = el('p', 'bb-sources', t('sources') + ': ');
  sources.forEach(function (s, i) {
    if (i) box.appendChild(txt(', '));
    var href = safeUrl(s);
    if (href) {
      var a = el('a', null, s);
      a.href = href;
      a.rel = 'noopener';
      add(box, a);
    } else {
      add(box, txt(String(s)));
    }
  });
  add(body, box);
}

/* ---- restore, and the hook theme/qa/brassboy-rail.qa.html drives ---- */

if (ss(OPEN_KEY) === '1') openPanel();

window.BrassBoy = {
  open: openPanel,
  close: closePanel,
  card: function (component, payload) { if (!panel) buildPanel(); renderCard(component, payload); },
  config: CFG
};
})();
